<template>
  <div>
    <van-nav-bar
      title="联络站详情信息"
      left-text="返回"
      right-text="主页"
      left-arrow
      @click-right="handleHome"
      @click-left="onClickLeft"
    />
    <van-collapse v-model="activeNames" >
      <van-collapse-item class="top" title="联络站基本信息" name="1">
        <div class="llz_pic">
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(item, index) in srcList" :key="index">
                <img :src="item" style="width: 100%" />
              <!-- <div v-if="image && image.indexOf('http') >= 0">
                <img :src="image" style="width: 100%" />
              </div>
              <div v-if="image && image.indexOf(1) >= 0">
                <img :src="http2 + image + '&type=2'" style="width: 100%" />
              </div>
              <div v-else>
                <img
                  :src="require('@/assets/images/llz_demo.png')"
                  style="width: 100%"
                />
              </div> -->
            </van-swipe-item>
          </van-swipe>
        </div>
        <van-button type="info" @click="handleLlzWz" style="margin-left: 35%;">联络站位置</van-button>
        <van-cell-group>
          <van-cell title="联络站名称" :value="point.llzName" is-link :url="url" />
          <van-cell title="联络站地址" :value="point.address" />
          <van-cell title="联系人姓名" :value="point.principal" />
          <van-cell title="联系人电话" :value="point.phone" />
          <van-cell title="接待时间" :value="point.date" />
          <van-cell title="接待频次" :value="point.jdnum" />
          <van-cell title="联系一府两院" :value="point.lxjbname" />
        </van-cell-group>
      </van-collapse-item>
      <van-collapse-item title="代表信息" name="2">
        <van-tabs v-model="active">
          <van-tab title="省人大代表">
            <div
              v-if=" point.resp && point.resp.level1 && point.resp.level1.length > 0 "

            >
              <div class="flex">
                <div
                  class="db_info"
                  v-for="item in point.resp.level1"
                  :key="item.id"
                  @click="toLink(item)"
                >
                  <img :src="http2 + item.dbHeadicon + '&type=1'" width="60" />
                  <p>{{ item.dbName }}</p>
                </div>
              </div>
            </div>
            <div v-else class="nodata">暂无我们的代表</div>
          </van-tab>
          <van-tab title="市人大代表">
            <div
              v-if="
                point.resp && point.resp.level2 && point.resp.level2.length > 0
              "
            >
              <div class="flex">
                <div
                  class="db_info"
                  v-for="item in point.resp.level2"
                  :key="item.id"
                  @click="toLink(item)"
                >
                  <img :src="http2 + item.dbHeadicon + '&type=1'" width="60" />
                  <p>{{ item.dbName }}</p>
                </div>
              </div>
            </div>
            <div v-else class="nodata">暂无我们的代表</div>
          </van-tab>
          <van-tab title="县人大代表">
            <div
              v-if="
                point.resp && point.resp.level3 && point.resp.level3.length > 0
              "
            >
              <div class="flex">
                <div
                  class="db_info"
                  v-for="item in point.resp.level3"
                  :key="item.id"
                  @click="toLink(item)"
                >
                  <img :src="http2 + item.dbHeadicon + '&type=1'" width="60" />
                  <p>{{ item.dbName }}</p>
                </div>
              </div>
            </div>
            <div v-else class="nodata">暂无我们的代表</div>
          </van-tab>
          <van-tab title="乡人大代表（街道议政员）">
            <div
              v-if="
                point.resp && point.resp.level4 && point.resp.level4.length > 0
              "
            >
              <div class="flex">
                <div
                  class="db_info"
                  v-for="item in point.resp.level4"
                  :key="item.id"
                  @click="toLink(item)"
                >
                  <img v-if="item.rolesName.includes($config.role.role_1.name)" :src="http + item.dbHeadicon + '&type=1'" width="60" />
                  <img v-if="!item.rolesName.includes($config.role.role_1.name)" :src="http2 + item.dbHeadicon + '&type=1'" width="60" />
                  <p>{{ item.dbName }}</p>
                </div>
              </div>
            </div>
            <div v-else class="nodata">暂无我们的代表</div>
          </van-tab>
        </van-tabs>
      </van-collapse-item>
      <van-collapse-item title="联络站活动" name="3">
        <div v-if="!point.llzhd || point.llzhd.length <= 0">
          <van-empty
            class="custom-image"
            image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无活动"
            style="width: 100%; height: 180px"
          />
        </div>
        <div
          v-else
          v-for="item in point.llzhd"
          :key="item.id"
          class="textitem"
        >
          <span class="gg_title">{{ item.hdname }}</span>
          <span class="gg_date">{{ item.hdsj }}</span>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import request from '@/api/getLLZ.js'
export default {
  data () {
    return {
      loading: false,
      pageIndex: 1,
      pageSize: 10,
      userid: '3306810012',
      styles: '',
      activeNames: ['1'],
      point: {},
      llzimg: [require('@/assets/images/llz_demo.png')],
      http: this.$api,
      http2: null,
      active: 0,
      points: {},
      colectList: [],
      url: null,
      srcList: []
    }
  },
  created () {
    this.point = this.$route.query.point
    this.http2 = process.env.VUE_APP_API_BASE_DBIMAGE_URL + 'api/admin/file/download?fileId='
    this.url = process.env.VUE_APP_BASE_PC_URL + '#/llzInfo?id='
  },
  mounted () {
    this.point = this.$route.query.point
    if (!this.point.llzName) {
      this.getLLZinfo()
    }
  },
  methods: {
    handleLlzWz () {
      this.$router.push({
        path: '/LLZmap',
        query: { id: this.$route.query.point }
      })
    },
    onClickLeft () {
      this.$router.back(-1)
    },
    handleHome () {
      this.$router.push('/home')
    },
    toLink (val) {
      location.href = process.env.VUE_APP_BASE_PC_URL + '#/infodetail_qr?id=' + val.id + '&from=wxoa'
    },
    handleRouterXq (id) {
      if (typeof id === 'number') {
        id += ''
      }
      this.$router.push({
        path: '/zjxqdetail',
        query: {
          id
        }
      })
    },
    //   获取数据
    getLLZinfo () {
      // this.loading = true
      request
        .getLlzDetail(this.point)
        .then((Response) => {
          this.point = Response
          if (Response.llzimg) {
            const images = Response.llzimg.split(',')
            const list = []
            images.map(item => {
              if (item.indexOf('http') > 0) {
                return list.push(item)
              } else {
                return list.push(`${this.http2 + item}&type=2`)
              }
            })
            this.srcList = list
            console.log(this.srcList)
          } else if (!Response.llzimg) {
            this.srcList = [require('@/assets/images/llz_demo.png')]
          }
          this.url = this.url + this.point.id + '&from=wxoa'
          // this.loading = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    //   获取意见征集数据
    getColectInfo () {
      this.styles = '意见征集'
      request
        .getColectList(this.pageIndex, this.pageSize, this.styles)
        .then((Response) => {
          this.colectList = Response.list
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="less" scoped>

/deep/ .van-cell--clickable{
    font-weight: 600;
}
/deep/ .van-collapse-item__content {
  padding: 3.2vw 1.26vw;
}
.textitem{
    padding: 10px 20px;
    .gg_title{
        font-weight: 500;
    }
    .gg_date{
        float: right;
    }
}
.llz_pic {
  width: 100%;
  img{
    width: 100%;
    height: 400px;
  }
}
.flex {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.flex :after {
  content: "";
  flex: auto;
}
.db_info {
  text-align: center;
  width: 25%;
  margin-top: 10px;
  margin-bottom: 20px;
}
.db_info:last-child {
  margin-right: 0px;
}

.db_info img {
  width: 105px;
  height: 150px;
}
.db_info p {
  margin: 0px;
  padding: 0px;
}
.nodata {
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 500;
}
</style>
